import { useHistory, useLocation, withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { LayoutSingleColumn, Page } from "../../components";
import FooterComponent from "../FooterContainer/FooterContainer";
import TopbarContainer from "../TopbarContainer/TopbarContainer";
import css from "./AdminBlogPage.module.css"
import { manageDisableScrolling, isScrollingDisabled } from "../../ducks/ui.duck";
import { connect } from "react-redux";
import { compose } from "redux";
import { injectIntl } from "react-intl";
import AdminBlogPostForm from "./AdminBlogPostForm";
import { createBlog, editBlog } from "../../util/api";
import { useState, useEffect } from "react";
import { createResourceLocatorString } from "../../util/routes";
import { FormattedMessage } from 'react-intl';
import { useRouteConfiguration } from "../../context/routeConfigurationContext";

export const AdminBlogPageComponent = props => {
    const [file, setFile] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const routeConfiguration = useRouteConfiguration();
    const [submitType, setSubmitType] = useState("draft");


    const {
        scrollingDisabled,
        onManageDisableScrolling,
        currentUser
    } = props;

    useEffect(() => {
        const fetchBlogData = async () => {
            if (location?.state?.blog) {
                setIsEditMode(true);
                setInitialValues({
                    title: location?.state.blog.title,
                    description: location?.state.blog.description,
                    content: location?.state.blog.content,
                    image:location?.state.blog.image,
                    _id: location?.state.blog._id,
                    readTime:location?.state?.blog?.readTime

                });
            }
        };
        fetchBlogData();
    }, [location?.state]);

    const handleSubmit = async (data) => {
        try {
            setIsLoading(true);
            let secureUrl = null;
            
            if (file) {
                const uploadURL = process.env.REACT_APP_CLOUDINARY_URL;
                const formDataCloud = new FormData();
                formDataCloud.append("file", file);
                formDataCloud.append("upload_preset", process.env.REACT_APP_CLOUDINARY_PRESET);
                const cloudinaryResponse = await fetch(uploadURL, {
                    method: "POST",
                    body: formDataCloud,
                });

                const cloudinaryData = await cloudinaryResponse.json();
                secureUrl = cloudinaryData.secure_url;
            } else if (isEditMode && !file) {
                secureUrl = location.state?.blog?.image;
            }

            const payload = {
                ...data,
                status: submitType 
            };

            let result;
            if (isEditMode) {
                result = await editBlog({ data: { ...payload, _id: initialValues._id }, secureUrl });
            } else {
                result = await createBlog({ payload, secureUrl });
            }
            
            if (result) {
                history.push(createResourceLocatorString('PostPage', routeConfiguration, { id: result?.data?._id, slug: result?.data?.slug }, {}));
            }
        } catch (error) {
            console.error('Error saving blog:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Page title={"Everything Fractional"} scrollingDisabled={scrollingDisabled} >
            <LayoutSingleColumn
                topbar={
                    <TopbarContainer
                        className={css.topbar}
                        mobileRootClassName={css.mobileTopbar}
                        desktopClassName={css.desktopTopbar}
                        currentPage="AdminBlogPage"
                    />
                }
                footer={<FooterComponent />}
                className={css.pageRoot}
            >
                <div className={css.adminContainer}>
                <h4 className={css.pageTitle}>
                    {isEditMode ? 
                        <FormattedMessage id="AdminBlogPage.editTitle" defaultMessage="Edit Blog Post" /> : 
                        <FormattedMessage id="AdminBlogPage.createTitle" defaultMessage="Create New Blog Post" />
                    }
                </h4>

                <div className={css.formWrapper}>
                    <AdminBlogPostForm 
                        onSubmit={handleSubmit} 
                        setFile={setFile} 
                        initialValues={initialValues}
                        isEditMode={isEditMode}
                        isLoading={isLoading}
                        file={file}
                        setSubmitType={setSubmitType}
                        submitType={submitType}
                    />
                </div>
                </div>
            </LayoutSingleColumn>
        </Page>
    );
};



const mapStateToProps = state => {
    const { currentUser } = state.user;
    return {
        currentUser,
        scrollingDisabled: isScrollingDisabled(state),
    };
};

const mapDispatchToProps = dispatch => ({
    onManageDisableScrolling: (componentId, disableScrolling) =>
        dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

const AdminBlogPage = compose(
    withRouter,
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    injectIntl
)(AdminBlogPageComponent);

export default AdminBlogPage;